(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('similarity-report-settings', {
            parent: 'account',
            url: '/similarity-report-settings',
            data: {
                authorities: ['PERM_USER_ADMIN'],
                pageTitle: 'global.menu.account.similarity.report.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/similarity-report-settings/similarity-report-settings.html',
                    controller: 'SimilarityReportSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('similarity');
                    $translatePartialLoader.addPart('users');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
